export const AMBASSADORS_GET_PAYOUT = 'AMBASSADORS_GET_PAYOUT'
export const AMBASSADORS_SET_PAYOUT = 'AMBASSADORS_SET_PAYOUT'
export const AMBASSADORS_SET_PAYOUT_PROCESSING = 'AMBASSADORS_SET_PAYOUT_PROCESSING'

export function getAmbassadorPayouts (payload) {
  return { type: AMBASSADORS_GET_PAYOUT, payload }
}
